import React from "react";
import SelectSection from "./parts/filters/SelectSection";
import MultiSelectSection from "./parts/filters/MultiSelectSection";
import SLBrandModelCascade from "./parts/filters/SLBrandModelCascade";
import SLMinMaxKm from "./parts/filters/SLMinMaxKm";
import SLMinMaxYear from "./parts/filters/SLMinMaxYear";
import SLMinMaxM2 from "./parts/filters/SLMinMaxM2";

// `kmInput`/`yearInput` (create-only) collapse to range UI on the search
// sidebar — the search-side equivalents are `minMaxKm`/`minMaxYear`.
const getFilterSection = (filter) => ({
  multiSelect: <MultiSelectSection filter={filter} key={filter.slug} />,
  singleSelect: <SelectSection filter={filter} key={filter.slug} />,
  multiCheck: <MultiSelectSection filter={filter} key={filter.slug} />,
  brandModelCascade: <SLBrandModelCascade filter={filter} key={filter.slug} />,
  kmInput: <SLMinMaxKm filter={filter} key={filter.slug} />,
  minMaxKm: <SLMinMaxKm filter={filter} key={filter.slug} />,
  yearInput: <SLMinMaxYear filter={filter} key={filter.slug} />,
  minMaxYear: <SLMinMaxYear filter={filter} key={filter.slug} />,
  m2Input: <SLMinMaxM2 filter={filter} key={filter.slug} />,
  minMaxM2: <SLMinMaxM2 filter={filter} key={filter.slug} />,
});

const FilterSidebar = (props) => {
  return props.filters.map(
    (filter) => getFilterSection(filter)[filter.filterType]
  );
};

export default FilterSidebar;
